$(document).ready(function () {
    const $loading = document.querySelector("#loading");
    const $loadWrap = document.querySelector(".load-wrap");

    var loading = function () {
        setTimeout(() => {
            $loading.classList.add("loaded");
            $loadWrap.classList.add("loaded-wrap");
        }, 2800);
    };

    // テスト用（本番アップ時にはcookieを適用する）
    // $loading.classList.add("show");
    // loading();

    // cookieにより一度、表示したら一定時間表示しないようにする
    if (!$.cookie("loading_shown")) {
        $loading.classList.add("show");

        loading();

        // cookieの付与
        let setTime = new Date();
        setTime.setTime(setTime.getTime() + 5 * 60 * 1000); //5分
        // $loading.show();
        $.cookie("loading_shown", new Date().getTime(), { expires: setTime });
    } else {
        $loading.classList.add("loaded");
        $loadWrap.classList.add("loaded-wrap");
    }
});
